import React from 'react'
import ReactDOM from "react-dom"

import Popover from "../../core/gd-components/gd-popover/popover-v2"
import PopoverPosition from "../../core/gd-components/gd-popover/popover-position"
import {addClass, removeClass} from "../../core/gd/utils/dom-and-react/react-utils";


type ContextMenuHover = {
    component?           : any // react component
    className?          : string
    onToggle?           : {(isShown: boolean):void},
}

const CONTEXT_LAYER_ID          = 'ui-context-menu-layout'
const DEFAULT_HOVER_CLASS_NAME  = 'with-context-menu'

// const debug = "LayoutContextMenu"
const debug = false

export default class LayoutContextMenu {

    public hover?                   : ContextMenuHover

    private refContextMenuAnchor    : React.RefObject<any> = React.createRef<any>()
    private _isShown                : boolean = false

    public show(e: React.MouseEvent | MouseEvent, menu: any, hover?: ContextMenuHover) {

        this.hover = hover

        if (!gd.user.settings.views.rightClickMoreMenu) return false

        this._isShown = true

        e.preventDefault()
        e.stopPropagation()

        debug && console.log(debug, 'show', e, menu)

        const contextMenuLayout = document.createElement("div")
        contextMenuLayout.id = CONTEXT_LAYER_ID

        // gd.layout.domZero.append(contextMenuLayout)
        document.body.append(contextMenuLayout)

        const anchorStyles: any = {
            position    : 'absolute',
            top         : e.pageY + 'px',
            left        : e.pageX + 'px',
            width       : 1,
            height      : 1,
        }

        const popoverPosition = new PopoverPosition({
            attachment      : "top left",
            targetAttachment: "bottom right",
        })

        //onClick={this.hide}
        ReactDOM.render(
            <div className="ui-context-menu" onContextMenu={this.onContextMenu}>
                <div ref        = {this.refContextMenuAnchor}
                     className  = "context-menu-anchor"
                     style      = {anchorStyles}/>
                <Popover popoverClass       = "gd-view-more-popover p-0"
                         position           = {popoverPosition}
                         getTargetFunc      = {()=>this.refContextMenuAnchor?.current}
                         onClickOutside     = {this.onClickOutside}
                >
                    {menu}
                </Popover>
            </div>,
            contextMenuLayout,
            () => {
                // Hover
                if (this.hover) {
                    if (this.hover.onToggle) {
                        this.hover.onToggle(true)
                    } else {
                        const classNamesArray = _.get(this.hover, 'className', DEFAULT_HOVER_CLASS_NAME).split(' ')
                        _.map(classNamesArray, className=>{
                            this.hover!.component && addClass(this.hover!.component, className)
                        })
                    }
                }
            }
        )
    }

    public hide = (e?: React.SyntheticEvent) => {
        debug && console.log(debug, 'hide', e)

        this._isShown = false

        // Hover
        if (this.hover) {
            if (this.hover.onToggle) {
                this.hover.onToggle(false)
            } else {
                const classNamesArray = _.get(this.hover, 'className', DEFAULT_HOVER_CLASS_NAME).split(' ')
                _.map(classNamesArray, className=>{
                    this.hover!.component && removeClass(this.hover!.component, className)
                })
            }
        }

        const element: any = document.getElementById(CONTEXT_LAYER_ID)
        if (!element) return

        ReactDOM.unmountComponentAtNode(element)
        element.remove()
    }

    onClickOutside = (e?: React.MouseEvent) => {
        // there may be no event if method is called outside (i.e. Popovers.closeAll())
        // then do not ignore call if no event
        const ignoreClick = e && !gd.utils.Dom.findNodeByClassName(e.target, ["ui-context-menu"])

        debug && console.log(debug, 'onClickOutside', ignoreClick, e?.target, e)

        if (!ignoreClick) {
            this.hide()
        }
    }

    get isShown(): boolean {
        return this._isShown;
    }

    private onContextMenu = (e: React.MouseEvent) => {
        e.preventDefault()
        this.hide()

        // Pass the event to the node underneath
        setTimeout(() => {

            // Get all the elements under the mouse position
            const elementsUnderMouse = document.elementsFromPoint(e.pageX, e.pageY);

            _.some(elementsUnderMouse, (el) => {
                if (!el.classList.contains('ui-context-menu')) {
                    const newEvent = new MouseEvent('contextmenu', e as any)
                    el.dispatchEvent(newEvent)
                    return true
                }
            })
        }, 0)
    }
}